"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndeadResolveEffectHandler = exports.UndeadResolveEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Regeneration_1 = require("./Regeneration");
class UndeadResolveEffectArgs {
    constructor(healthPercent) {
        this.healthPercent = healthPercent;
        this.__type = EffectType_1.EffectType.UndeadResolve;
        this.__typeName = "UndeadResolve";
        this.name = "UndeadResolve";
        this.harmful = true;
    }
}
exports.UndeadResolveEffectArgs = UndeadResolveEffectArgs;
let UndeadResolveEffectHandler = class UndeadResolveEffectHandler {
    apply(sequence, container, state) {
        const amount = (state.args.healthPercent / 100) * container.getMaxAttributeScore(state.targetId, enums_1.AttributeType.Health);
        container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new Regeneration_1.RegenerationEffectArgs("UndeadResolve", amount),
            duration: Duration_1.Duration.Permanent,
            hidden: true,
            supernatural: true
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
    }
};
UndeadResolveEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.UndeadResolve)
], UndeadResolveEffectHandler);
exports.UndeadResolveEffectHandler = UndeadResolveEffectHandler;
